
$(function() {
    $(".widget-hidden-opts").each(function(idx, element) {
        var $header = $(element).find(".opts-header");
        var $title = $(element).find(".opts-header span");

        $header.click(function() {
            var isExpanded = $(element).hasClass("expanded");

            if (isExpanded) {
                $title.html("More Options");
                $(element).removeClass("expanded");
            }
            else {
                $title.html("Less Options");
                $(element).addClass("expanded");
            }
        });
    });
})